// src/components/navbar/Navbar.js
import React from 'react';
import LanguageSwitcher from '../languageSwitcher/LanguageSwitcher';
import './Navbar.scss';
import { useTranslation } from 'react-i18next';
import Icons from '../../utils/icons/Icons';
import { useAuth } from '../../contexts/AuthContext';

const Navbar = () => {
  const { t } = useTranslation();
  const { sessionTimeLeft } = useAuth();
  // Helper function to format the countdown
  const formatTimeLeft = (timeLeft) => {
    const minutes = Math.floor(timeLeft / 60);
    const seconds = Math.floor(timeLeft % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  return (
    <div className="navbar">
      <div className="logo">
        <img src="logo.svg" alt="Logo" />
        <span>{t('app_name')}</span>
      </div>
      <div className="icons">
        <Icons.SearchIcon className="icon" />
        <Icons.NotificationsIcon className="icon" />
        <div className="user">
          <img
            src="https://images.pexels.com/photos/11038549/pexels-photo-11038549.jpeg?auto=compress&cs=tinysrgb&w=1600&lazy=load"
            alt="User"
          />
          <span>Jane</span>
        </div>
        <Icons.SettingsIcon className="icon" />
        <LanguageSwitcher /> {/* Add the language switcher here */}
        {/* Display session time left */}
        {sessionTimeLeft !== null && (
          <div className="session-timer">
            Session Time Left: {formatTimeLeft(sessionTimeLeft)}
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
